var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        title: _vm.$t("billing.skipTrialVersion"),
        "cancel-text": _vm.$t("message.cancel"),
        "ok-text": _vm.$t("message.confirm"),
        "show-footer": true,
      },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [_c("div", [_vm._v(_vm._s(_vm.$t("billing.skipTrialVersionDesc")))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }